import { render, staticRenderFns } from "./LoggerDescription.vue?vue&type=template&id=71249434&"
import script from "./LoggerDescription.vue?vue&type=script&lang=js&"
export * from "./LoggerDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports